export default function Condition(props) {
    return props.assert ? props.children : false;
};
